import React, { useEffect, useRef, useState } from "react";
import { FilterWrapper } from "../../../assets/styles/FilterStyle.js";
import { TableWrapper } from "../../../Components/styledConstant.js";
import { AddAirline, AddAirport, AddNewHotel, fetchCountryList, getAirlineList, getAirportList, getHotelList, getSuggestList, updateAirlineStatus, updateAirportStatus, UpdateHotelStatus } from "../../../utils/api.js";
import Pagination from "../../../Components/Pagination/Pagination.jsx";

import { useNavigate } from "react-router-dom";
import AutoSuggestion from "../../../Components/AutoSuggest/AutoSuggest.js";
import debounce from "lodash.debounce";
import Input from "../../../Components/Input/Input.jsx";
import { ModalPopUp } from "../../../Components/ModalPopUp/ModalPopUp.jsx";
import LocalLoader from "../../../Components/Loader/LocalLoader.js";
import { useDebounce } from "../../../Components/hooks/useDebounce.js";




const AddNewAirport = () => {
      const [newHotelData, setNewHotelData] = useState({
             code: null,
             name: null,
             city: null,
             country: null,
            // countryCode: null,
             northEastLongitude: null,
             northEastLatitude: null,
             southWestLongitude: null ,
             southWestLatitude: null,
             active: null,
             popular:null
        
       });
       const [showHotel,SetShowHotel] = useState(false);
       const [errors, setErrors] = useState({});
       const[loading,setLoading] = useState(false);
      const [countryList, setCountryList] = useState([]);
         const [filteredCountries, setFilteredCountries] = useState([]);
         const [isOpen, setIsOpen] = useState(false);
       
         const [message, setMessage] = useState("");
        const debounceValue = useDebounce(newHotelData?.country, 500);
       
         useEffect(() => {
           fetchCountryList()
             .then((response) => {
               setCountryList(response?.data?.data?.countries || []);
             })
             .catch((error) => {
               console.error("Failed to fetch country list:", error);
             });
         }, []);
       
         useEffect(() => {
           const filtered = countryList.filter((country) => (country?.name || "").toLowerCase().includes((debounceValue || "").toLowerCase()));
           setFilteredCountries(filtered || [])
         }, [debounceValue, countryList]);
   
         const handleCountrySelect = (country) => {
          setNewHotelData((prevData) => ({
            ...prevData,
            country: country.name,
            countryCode: country.iso2,
          }));
          setIsOpen(false)
          setFilteredCountries([]);
        };
    
         const handleModalInputChange = (e) => {
        const { name, value } = e.target;
        setNewHotelData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

       const validateForm = () => {
        const newErrors = {};
        if (!newHotelData.code) newErrors.code = "Code is required";
        if (!newHotelData.name) newErrors.name = "Name is required";
        if (!newHotelData.city) newErrors.city = "City is required";
        if (!newHotelData.country) newErrors.country = "Country Name is required";
        if (!newHotelData.countryCode) newErrors.countryCode = "Country Code is required";
        if (!newHotelData.northEastLongitude) newErrors.northEastLongitude = "North East Longitude is required";
        if (!newHotelData.northEastLatitude) newErrors.northEastLatitude = "North East Latitude is required";
        if (!newHotelData.southWestLongitude) newErrors.southWestLongitude = "South West Longitude is required";
        if (!newHotelData.southWestLatitude) newErrors.southWestLatitude = "South West Latitude is required";
        if (newHotelData.active === "") newErrors.active = "Status is required";
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
      };
      

       const handleSubmit = ()=>{
       
        if (!validateForm()) {
            return; 
          }
      
       
        if(newHotelData.active ==="true"){
         newHotelData.active = true
        } else{
         newHotelData.active = false;
       }
        
         AddAirport(newHotelData).then((resp)=>{
        if(resp){
           SetShowHotel(false);
        //   showHotelList(currPage);
       
        }
       
         })
       }
       console.log("errors",filteredCountries);

      return(
        <>
          <div className="main_container">
       <div className="userlist_head mb-5">

     <div className="userlist_heading">
        <div className="userlist_left">
          <label>Add New Airport</label>
        </div>
        </div>
        </div>
             
        
         <div className="container justify-between flex column gap-20" style={{width:"50%"}}>
         <div style={{flex:"1 1 100%"}}>
        <div className="flex gap-10">
                 <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Code:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Code"
                  name="code"
                 value={newHotelData.code}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.code && (
                  <p className="error fs-12 mt-10">{errors.code}</p>
                )}
              </div>

              <div className="input-field"  style={{flex:"1 1 50%"}}>
              <div className="labelname mb-5">
                  <label className="fw-bold">Slect Status:</label>
                
                </div>
                    <select
                    style={{width:"100%", maxWidth:"330px"}}
                      className="input_select_field"
                      name="active"
                   value={newHotelData.active}
                  onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">Select Status</option> 
                     <>
                      <option value={true}>ACTIVE</option>
                     <option value={false}>INACTIVE</option>
                      </>
                    </select>
              </div>
          </div>
        
        
        
        
        <div className="flex gap-10 mt-10">

        
          <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">Name:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="Name"
                  name="name"
                 value={newHotelData.name}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.name && (
                  <p className="error fs-12 mt-10">{errors.name}</p>
                )}
              </div>

              <div style={{flex:"1 1 50%"}}>
                <div className="labelname mb-5">
                  <label className="fw-bold">City:</label>
                
                </div >
                <Input
                  type="text"
                  maxLength={10}
                placeholder="City"
                  name="city"
                 value={newHotelData.city}
               onChange={handleModalInputChange}
             
                 // click={checkStatus}
                />
                {errors.city && (
                  <p className="error fs-12 mt-10">{errors.city}</p>
                )}
              </div>
    </div>


     
        
    <div className="flex gap-10 mt-10">

        
   <div style={{flex:"1 1 50%"}}>
      <div className="labelname mb-5">
        <label className="fw-bold">Country:</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="Name"
        name="country"
       value={newHotelData.country}
     onChange={handleModalInputChange}
     onFocus={()=>setIsOpen(true)}
   
       // click={checkStatus}
      />
      {errors.country && (
        <p className="error fs-12 mt-10">{errors.country}</p>
      )}
       {filteredCountries.length > 0 && isOpen && (
                <div className="dropdown mt-10" style={{maxWidth:"330px",width:"100%"}}>
                  {filteredCountries.map((country) => (
                    <div
                      key={country.iso2}
                      className="dropdown-item fs-14"
                      style={{paddingBottom:"5px",borderBottom:"1px solid #8080803d",paddingTop:"5px"}}
                      onClick={() => handleCountrySelect(country)}
                    >
                      {country.name} ({country.iso2})
                    </div>
                  ))}
                </div>
              )}
    </div>
             
    <div className="input-field" style={{flex:"1 1 50%",maxWidth:"330px"}}>
               <div className="labelname mb-5">
                  <label className="fw-bold">Popular:</label>
               </div >
                 
                    <select
                      className="input_select_field"
                      name="active"
                     value={newHotelData?.popular}
                      onChange={handleModalInputChange}
                    >
                      {/* <option value={""}>User Type</option> */}
                   
                      <option value="">Popular</option> 
                     <>
                      <option value={"true"}>Yes</option>
                     <option value={"false"}>No</option>
                      </>
                    </select>
                  </div>
                 

  
    
    
    </div>

    <div className="flex gap-10 mt-10">

        
     <div style={{flex:"1 1 50%"}}>
      <div className="labelname mb-5">
        <label className="fw-bold">North East Longitude:</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="North East Longitude"
        name="northEastLongitude"
       value={newHotelData.northEastLongitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.northEastLongitude && (
        <p className="error fs-12 mt-10">{errors.northEastLongitude}</p>
      )}
    </div>

    <div style={{flex:"1 1 50%"}}>
      <div className="labelname mb-5">
        <label className="fw-bold">North East Latitude:</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="North East Latitude"
        name="northEastLatitude"
       value={newHotelData.northEastLatitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.northEastLatitude && (
        <p className="error fs-12 mt-10">{errors.northEastLatitude}</p>
      )}
    </div>
    </div>

    <div className="flex gap-10 mt-10">

        
     <div style={{flex:"1 1 50%"}}>
      <div className="labelname mb-5">
        <label className="fw-bold">South West Longitude:</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="south West Longitude"
        name="southWestLongitude"
       value={newHotelData?.southWestLongitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.southWestLongitude && (
        <p className="error fs-12 mt-10">{errors?.southWestLongitude}</p>
      )}
    </div>

    <div style={{flex:"1 1 50%"}}>
      <div className="labelname mb-5">
        <label className="fw-bold">South West Latitude:</label>
      
      </div >
      <Input
        type="text"
        maxLength={10}
      placeholder="South West Latitude"
        name="southWestLatitude"
       value={newHotelData?.southWestLatitude}
     onChange={handleModalInputChange}
   
       // click={checkStatus}
      />
      {errors.southWestLatitude && (
        <p className="error fs-12 mt-10">{errors.southWestLatitude}</p>
      )}
    </div>
    </div>

    
    
             

       
                  <div className="mt-20">
          <button onClick={handleSubmit} className="userlist_btn">Submit</button>
        </div>
         

         </div>
       
        
         </div>

         </div>
        </>
      )

}
export default AddNewAirport;